import React, { useEffect, useState } from 'react';
import styles from './Search.module.css';
import { Search as SearchIcon } from 'lucide-react';

export default function Search({ label = 'Search', value, onChange, className, ...props }) {
    const [local, setLocal] = useState(value || '');
    useEffect(() => { setLocal(value || ''); }, [value]);

    const handle = (e) => {
        const v = e.target.value;
        setLocal(v);
        onChange && onChange(v);
    };

    return (
        <label className={[styles.field, className].filter(Boolean).join(' ')}>
            <span className={styles.visuallyHidden}>{label}</span>

            <div className={styles.inputWrapper}>
                <input
                    type="search"
                    className={styles.input}
                    value={local}
                    onChange={handle}
                    placeholder={label}
                    aria-label={label}
                    autoComplete="off"
                    {...props}
                />
                <span className={styles.searchIcon} aria-hidden="true">
                    <SearchIcon size={16} />
                </span>
            </div>
        </label>
    );
}
